import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { useLocation, useRouteMatch } from 'react-router';
import useSWR from 'swr';
import { OutpostDestination } from '../../../../../../../typings/outpost';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import Loading from '../../../common/base/Loading';
import Tabs from '../../../common/base/Tabs';
import { Div } from '../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { StyledViewContent, StyledViewNav, StyledViewNavHeader, StyledViewNavSecondary, StyledViewLayout, ViewBreadcrumbsTitle } from '../../../layouts/ViewLayout';
import NotFound from '../../DashboardScene/NotFound';
import { DestinationMetrics } from './DestinationMetrics';
import { DestinationOverview } from './DestinationOverview';
import { DestinationSettings } from './DestinationSettings';
const DestinationView = () => {
  const $ = _c(67);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    pathname
  } = useLocation();
  const {
    params: t0
  } = useRouteMatch();
  const {
    id,
    destination_id
  } = t0;
  let t1;
  if ($[0] !== destination_id || $[1] !== id) {
    t1 = APIMethodKeys.outpost.destinations.get(id, destination_id);
    $[0] = destination_id;
    $[1] = id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== HookdeckAPI.outpost.destinations || $[4] !== destination_id || $[5] !== id) {
    t2 = () => HookdeckAPI.outpost.destinations.get(id, destination_id);
    $[3] = HookdeckAPI.outpost.destinations;
    $[4] = destination_id;
    $[5] = id;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    data: destination,
    mutate,
    error
  } = useSWR(t1, t2);
  let t3;
  if ($[7] !== destination) {
    t3 = destination ? APIMethodKeys.outpost.destinationTypes.get(destination.type) : null;
    $[7] = destination;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== HookdeckAPI.outpost.destinationTypes || $[10] !== destination?.type) {
    t4 = () => HookdeckAPI.outpost.destinationTypes.get(destination?.type as string);
    $[9] = HookdeckAPI.outpost.destinationTypes;
    $[10] = destination?.type;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const {
    data: destination_type
  } = useSWR(t3, t4);
  const current_status = pathname.endsWith("/settings") ? "settings" : pathname.endsWith("/metrics") ? "metrics" : "overview";
  const t5 = `/tenants/${id}/destinations/${destination_id}`;
  let t6;
  if ($[12] !== t5) {
    t6 = {
      label: "Overview",
      key: "overview",
      to: t5
    };
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = `/tenants/${id}/destinations/${destination_id}/metrics`;
  let t8;
  if ($[14] !== t7) {
    t8 = {
      label: "Metrics",
      key: "metrics",
      to: t7
    };
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = `/tenants/${id}/destinations/${destination_id}/settings`;
  let t10;
  if ($[16] !== t9) {
    t10 = {
      label: "Settings",
      key: "settings",
      to: t9
    };
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t6 || $[20] !== t8) {
    t11 = {
      OVERVIEW: t6,
      METRICS: t8,
      SETTINGS: t10
    };
    $[18] = t10;
    $[19] = t6;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const TABS = t11 as const;
  let t12;
  if ($[22] !== mutate) {
    t12 = updated => {
      mutate(updated);
    };
    $[22] = mutate;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const mutate_destination = t12;
  if (error?.status === 404) {
    let t13;
    if ($[24] !== destination_id) {
      t13 = <NotFound title="Destination not found" description="This destination does not exist or has been deleted." id={destination_id} />;
      $[24] = destination_id;
      $[25] = t13;
    } else {
      t13 = $[25];
    }
    return t13;
  }
  if (error) {
    let t13;
    if ($[26] !== destination_id) {
      t13 = <NotFound title="Failed to load destination" description="An unexpected error occurred. Please try again." id={destination_id} />;
      $[26] = destination_id;
      $[27] = t13;
    } else {
      t13 = $[27];
    }
    return t13;
  }
  if (!destination) {
    let t13;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <Div m={{
        t: 8
      }}><Loading /></Div>;
      $[28] = t13;
    } else {
      t13 = $[28];
    }
    return t13;
  }
  let t13;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      label: "Tenants",
      to: "/tenants"
    };
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  const t14 = `/tenants/${id}`;
  let t15;
  if ($[30] !== id || $[31] !== t14) {
    t15 = {
      label: id,
      to: t14
    };
    $[30] = id;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      label: "Destinations"
    };
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== destination_id) {
    t17 = {
      label: destination_id,
      highlight: true
    };
    $[34] = destination_id;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t15 || $[37] !== t17) {
    t18 = [t13, t15, t16, t17];
    $[36] = t15;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  const breadcrumbs = t18;
  let t19;
  if ($[39] !== breadcrumbs) {
    t19 = <StyledViewNavHeader><ViewBreadcrumbsTitle breadcrumbs={breadcrumbs} /></StyledViewNavHeader>;
    $[39] = breadcrumbs;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== TABS) {
    t20 = Object.values(TABS);
    $[41] = TABS;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== current_status || $[44] !== t20) {
    t21 = <StyledViewNavSecondary><Tabs active_tab={current_status} border={false} tabs={t20} /></StyledViewNavSecondary>;
    $[43] = current_status;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== t19 || $[47] !== t21) {
    t22 = <StyledViewNav>{t19}{t21}</StyledViewNav>;
    $[46] = t19;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== current_status || $[50] !== destination || $[51] !== destination_type) {
    t23 = current_status === "overview" && <DestinationOverview destination={destination} destination_type={destination_type} />;
    $[49] = current_status;
    $[50] = destination;
    $[51] = destination_type;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== current_status || $[54] !== destination) {
    t24 = current_status === "metrics" && <DestinationMetrics destination={destination} />;
    $[53] = current_status;
    $[54] = destination;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== current_status || $[57] !== destination || $[58] !== destination_type || $[59] !== id || $[60] !== mutate_destination) {
    t25 = current_status === "settings" && <DestinationSettings tenant_id={id} destination={destination} destination_type={destination_type} mutate={mutate_destination} />;
    $[56] = current_status;
    $[57] = destination;
    $[58] = destination_type;
    $[59] = id;
    $[60] = mutate_destination;
    $[61] = t25;
  } else {
    t25 = $[61];
  }
  let t26;
  if ($[62] !== t22 || $[63] !== t23 || $[64] !== t24 || $[65] !== t25) {
    t26 = <StyledViewLayout><StyledViewContent>{t22}{t23}{t24}{t25}</StyledViewContent></StyledViewLayout>;
    $[62] = t22;
    $[63] = t23;
    $[64] = t24;
    $[65] = t25;
    $[66] = t26;
  } else {
    t26 = $[66];
  }
  return t26;
};
export default DestinationView;